import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import ModalHome from "../pages/components/ModalHome";

export default function ModalTimer() {
    const [openModalHome, setOpenModalHome] = useState(false);
    const location = useLocation();

    const paginasBloqueadas = [
        "/cadastro",
        "/login",
        "/regularize",
        "/economize",
    ];

    const bloquearModal =
        location.pathname === "/nichos" ||
        location.pathname.startsWith("/nichos/") ||
        location.pathname === "/dashboard" ||
        location.pathname.startsWith("/dashboard/") ||
        paginasBloqueadas.includes(location.pathname.toLowerCase());

    useEffect(() => {
        if (bloquearModal) return;

        const jaAbriu = sessionStorage.getItem("modal-contblack");

        if (jaAbriu) return;

        const timer = setTimeout(() => {
            setOpenModalHome(true);
            sessionStorage.setItem("modal-contblack", "true");
        }, 45000);

        return () => clearTimeout(timer);
    }, [bloquearModal]);

    if (bloquearModal) {
        return null;
    }

    return (
        <ModalHome
            openModalHome={openModalHome}
            setOpenModalHome={setOpenModalHome}
        />
    );
}